import { WeapiEventPayload } from './contracts';

const constructData = (
  envelope,
  data,
  payloadMetaAttributes,
): WeapiEventPayload => {
  return {
    ...envelope,
    customAttributes: {
      ...data,
      ...payloadMetaAttributes,
    },
  };
};

export default constructData;
